import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  categoryName: string;
  author: string;
  publishDate: string;
  readTime: string;
  imageUrl: string;
  tags: string[];
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  category,
  categoryName,
  author,
  publishDate,
  readTime,
  imageUrl,
  tags,
}: ArticleCardProps) {
  return (
    <article className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden group hover:border-primary-200 transition-colors">
      <Link to={`/article/${slug}`} className="block">
        <div className="aspect-[16/9] overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            title={`${title} - 六合彩指南`}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-3 mb-3 text-xs text-foreground-500 flex-wrap">
          <Link
            to={`/category/${category}`}
            className="px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium hover:bg-secondary-200 transition-colors whitespace-nowrap"
          >
            {categoryName}
          </Link>
          <span>{readTime}</span>
          <span>{publishDate}</span>
        </div>
        <Link to={`/article/${slug}`} className="block">
          <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">{excerpt}</p>
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-500">{author}</span>
          <div className="flex gap-1.5 flex-wrap">
            {tags.slice(0, 2).map((tag) => (
              <span key={tag} className="text-xs px-2 py-0.5 rounded bg-background-100 text-foreground-600">
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </article>
  );
}